var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['rounded-2xl border border-gray-200 bg-white p-6 shadow-sm', _vm.$attrs.class]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }